import {UpdatingSetting} from "../../data/models/UpdatingSetting";
import {isErrorStatus} from "../../ReadAndWrite/utils";

export const errorCountString = (updatingSettings: UpdatingSetting[]): string => {
    const errorCount: number = updatingSettings.filter(isErrorStatus).length;
    return errorCount > 0
        ? `${errorCount} error${errorCount > 1 ? 's' : ''}`
        : "";
}
